<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-radio-group v-model="config[field.key]" class="radio-group" type="flex" @change="change">
                <div v-for="(item,index) in field['radio-list']" :key="index" class="radio-item">
                    <el-radio :label="item.value"><img :src="item.url" alt="" :width="field.width"></el-radio>
                </div>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="背景图：" label-width="110px">
            <image-uploader :uploadedImg="config.property_data.background_image" @uploaded="backgroundImageHandleUpload"
                            class="small-image" :tip="background_image_memo"></image-uploader>
        </el-form-item>
        <el-form-item label="头像：" label-width="110px">
            <image-uploader :uploadedImg="config.property_data.head_image" @uploaded="headImageHandleUpload"
                            class="small-image" :tip="head_image_memo"></image-uploader>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
    .radio-group {
        .radio-item {
            display: inline-block;
            padding-right: 20px;
            margin-bottom: 10px;

            img {
                border: 1px solid #E3E7EE;
            }

            [aria-checked=true] img {
                border: 1px solid #4A8EF7;
            }
        }

    }
</style>

<script>

  import ImageUploader from '@/components/ImageUploader.vue';

  export default {
    name: 'tms-type-shop-header',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        radio: 0,
        background_image_memo: '建议宽度：750px*352px',
        head_image_memo: '建议宽度：160px*160px'
      }
    },

    watch: {
      styleType() {
        this.change(this.config[this.field.key]);
      }
    },

    computed: {
      styleType() {
        return this.config[this.field.key];
      }
    },

    components: {
      ImageUploader
    },

    mounted() {
      this.change(this.config[this.field.key]);
    },

    methods: {
      change(val) {
        switch (val) {
          case 1:
            this.background_image_memo = '建议宽度：750px*352px';
            this.head_image_memo = '建议宽度：160px*160px';
            break;
          case 2:
            this.background_image_memo = '建议宽度：750px*352px';
            this.head_image_memo = '建议宽度：160px*160px';
            break;
          case 3:
            this.background_image_memo = '建议宽度：750px*352px';
            this.head_image_memo = '建议宽度：160px*160px';
            break;
          case 4:
            this.background_image_memo = '建议宽度：750px*192px';
            this.head_image_memo = '建议宽度：160px*160px';
            break;
        }
      },
      backgroundImageHandleUpload(src, index) {
        this.$set(this.config.property_data, 'background_image', src);
      },
      headImageHandleUpload(src, index) {
        this.$set(this.config.property_data, 'head_image', src);
      },
    }
  }

</script>
